import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { reorder } from "../../utilities/draggingutils";
import ReactDOM from "react-dom";

export interface OrderableListProps<T> {
  listId?: string
  items: T[]
  getKey: (item: T) => string
  render: (item: T) => React.ReactNode
  onOrderChanged: (newItems: T[]) => void
  onDelete?: (item: T) => void
}

const OrderableList = <T extends any>(props: OrderableListProps<T>) => {
  const {
    listId = "orderable-list",
    items,
    getKey,
    render,
    onOrderChanged,
    onDelete,
  } = props;

  const onDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }

    const oldItems = [...items];
    const newItems = reorder(oldItems, result.source.index, result.destination.index);

    onOrderChanged(newItems);
  };

  const displayDelete = onDelete != null;

  const renderDetail = (item: T) => {
    return <>
      <div><a className="icon-order" /></div>
      {render(item)}

      {displayDelete && <PhosphorTrashButton
        layout="in-square"
        onClick={() => onDelete(item)} />}
    </>;
  };

  return <div className="list-with-gaps line-layout">
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={listId}>
        {(provider) => (
          <div ref={provider.innerRef} {...provider.droppableProps} className="list-with-gaps-body">
            {items.map((item, idx) => (
              <Draggable
                key={getKey(item)}
                draggableId={getKey(item)}
                index={idx}
              >
                {(prov, snap) => {
                  if (snap.isDragging) {
                    return ReactDOM.createPortal(<div
                      style={{ minHeight: 40 }}
                      ref={prov.innerRef}
                      {...prov.draggableProps}
                      {...prov.dragHandleProps}
                    >
                      <div className="orderable-list-row-dragged">
                        {renderDetail(item)}
                      </div>
                    </div>, document.body);
                  }

                  return <div
                    style={{ minHeight: 40 }}
                    ref={prov.innerRef}
                    {...prov.draggableProps}
                    {...prov.dragHandleProps}
                  >
                    {renderDetail(item)}
                  </div>;
                }}
              </Draggable>
            ))}
            {provider.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  </div>;
};

// window.onload = () => {
//   setInterval(() => {
//     const draggedItem = document.getElementsByClassName("orderable-list-row-dragged");
//     if (draggedItem.length > 0) {
//       console.log(draggedItem[0].innerHTML);
//       console.log(draggedItem[0].getBoundingClientRect());
//     }
//   }, 500);
// }

export default OrderableList;